import classNames from 'classnames';

import dashboardStyle from 'styles/shared/dashboardMealCard';
import * as Types from 'utilities/types';

const MealBadgeIcon = ({ mealBadge, microBadge = false, containerClass = '' }) => {
  return (
    <img
      src={mealBadge.url}
      alt={mealBadge.name}
      className={classNames(
        containerClass,
        microBadge
          ? 'absolute right-1 top-1 h-12 w-12 drop-shadow-md'
          : [
              dashboardStyle.mealBadge,
              mealBadge.name === 'RachaelRay'
                ? 'absolute right-1.5 top-1.5 w-40 drop-shadow-xl'
                : 'absolute -top-2 right-2 h-16 w-16 drop-shadow-xl',
            ]
      )}
    />
  );
};

MealBadgeIcon.propTypes = {
  mealBadge: Types.mealBadge.isRequired,
  microBadge: PropTypes.bool,
  containerClass: PropTypes.string,
};

export default MealBadgeIcon;
